export const phoneNumberPrefixes = [
  {
    value: "+52",
    label: "México (+52)",
    countryImage: "/images/flags/flag-mx.png",
    countryCode: "MX"
  },
  {
    value: "+34",
    label: "Spain (+34)",
    countryImage: "/images/flags/flag-es.png",
    countryCode: "ES"
  },
  {
    value: "+44",
    label: "UK (+44)",
    countryImage: "/images/flags/flag-en.png",
    countryCode: "UK"
  },

  {
    value: "+49",
    label: "Germany (+49)",
    countryImage: "/images/flags/flag-germany.png",
    countryCode: "DE"
  },
  {
    value: "+31",
    label: "Netherlands (+31)",
    countryImage: "/images/flags/flag-netherlands.png",
    countryCode: "NL"
  },
  {
    value: "+45",
    label: "Denmark (+45)",
    countryImage: "/images/flags/flag-denmark.png",
    countryCode: "DK"
  },
  {
    value: "+40",
    label: "Romania (+40)",
    countryImage: "/images/flags/flag-romania.png",
    countryCode: "RO"
  }
];

export const financesValues = {
  //show only last 4 years - TIN-91
  /*2019: {
    valuation: 865123,
    valuationPercentage: 30,
    mortageValue: 702416,
    mortagePercentage: 4,
    landValue: 392450,
    landPercentage: 5,
  },*/
  2020: {
    valuation: 365123,
    valuationPercentage: 15,
    mortageValue: 602416,
    mortagePercentage: 4,
    landValue: 362450,
    landPercentage: 5
  },
  2021: {
    valuation: 565123,
    valuationPercentage: 12,
    mortageValue: 402416,
    mortagePercentage: 4,
    landValue: 192450,
    landPercentage: 5
  },
  2022: {
    valuation: 665123,
    valuationPercentage: 16,
    mortageValue: 502416,
    mortagePercentage: 4,
    landValue: 192450,
    landPercentage: 5
  },
  2023: {
    valuation: 865123,
    valuationPercentage: 22,
    mortageValue: 702416,
    mortagePercentage: 4,
    landValue: 392450,
    landPercentage: 5
  }
};

export const purchaseValues = {
  active: [
    {
      name: "concierge.garden-maintenance-title",
      img: "/images/concierge/garden-maintenance.png",
      date: "25 April 2023"
    },
    {
      name: "concierge.home-insurance-title",
      img: "/images/concierge/home-insurance.png",
      date: "1 May 2023"
    },
    {
      name: "concierge.mortgage-title",
      img: "/images/concierge/mortgage.png",
      date: "5 May 2023"
    }
  ],
  pending: [
    {
      name: "concierge.laundry-title",
      img: "/images/concierge/laundry.png",
      date: "10 May 2023"
    },
    {
      name: "concierge.cleaning-title",
      img: "/images/concierge/cleaning.png",
      date: "24 May 2023"
    }
  ]
};

export const files = [
  {
    name: "Floor_plans.pdf",
    type: "pdf",
    uploadDate: "2021-05-01",
    archived: false
  },
  {
    name: "Garden.png",
    type: "png",
    uploadDate: "2021-05-03",
    archived: false
  },
  {
    name: "Damage_kitchen.jpg",
    type: "jpg",
    uploadDate: "2021-07-13",
    archived: false
  },
  {
    name: "Housing_contract.docx",
    type: "docx",
    uploadDate: "2021-09-25",
    archived: true
  }
];

export const alerts = {
  home: [
    {
      id: 0,
      category: "high",
      title: "area-registration",
      completed: true,
      description:
        "The denomination of the property registry and that held by the police do not coincide, there is no doubt that the land registry is correct, however a lawyer should clarify this discrepancy with the police before proceeding.",
      action:
        "Tinsa is able to recommend a local lawyer to resolve this issue between the police and the land registry. Get in touch with us for further information.",
      estimatedCost: 1500
    }
  ],
  area: [],
  finance: [],
  warnings: [
    {
      id: 0,
      category: "high",
      title: "area-registration",
      completed: true,
      description:
        "The denomination of the property registry and that held by the police do not coincide, there is no doubt that the land registry is correct, however a lawyer should clarify this discrepancy with the police before proceeding.",
      action:
        "Tinsa is able to recommend a local lawyer to resolve this issue between the police and the land registry. Get in touch with us for further information.",
      estimatedCost: 1500
    },
    {
      id: 1,
      category: "high",
      title: "police-land-registry",
      completed: true,
      description:
        "The denomination of the property registry and that held by the police do not coincide, there is no doubt that the land registry is correct, however a lawyer should clarify this discrepancy with the police before proceeding.",
      action:
        "Tinsa is able to recommend a local lawyer to resolve this issue between the police and the land registry. Get in touch with us for further information.",
      estimatedCost: 2500
    },
    {
      id: 2,
      category: "medium",
      title: "urban-regulations",
      completed: true,
      description:
        "The denomination of the property registry and that held by the police do not coincide, there is no doubt that the land registry is correct, however a lawyer should clarify this discrepancy with the police before proceeding.",
      action:
        "Tinsa is able to recommend a local lawyer to resolve this issue between the police and the land registry. Get in touch with us for further information.",
      estimatedCost: 1300
    }
    // {
    //   id: 3,
    //   category: "low",
    //   title: "area-registration",
    //   completed: false,
    //   description:
    //     "The denomination of the property registry and that held by the police do not coincide, there is no doubt that the land registry is correct, however a lawyer should clarify this discrepancy with the police before proceeding.",
    //   action:
    //     "Tinsa is able to recommend a local lawyer to resolve this issue between the police and the land registry. Get in touch with us for further information.",
    //   estimatedCost: 1200,
    // },
    // {
    //   id: 4,
    //   category: "low",
    //   title: "urban-regulations",
    //   completed: false,
    //   description:
    //     "The denomination of the property registry and that held by the police do not coincide, there is no doubt that the land registry is correct, however a lawyer should clarify this discrepancy with the police before proceeding.",
    //   action:
    //     "Tinsa is able to recommend a local lawyer to resolve this issue between the police and the land registry. Get in touch with us for further information.",
    //   estimatedCost: 1000,
    // },
  ]
};

export const SwipeCard = ({ id, currentValuationId, t, getPropertyImage }) => {
  let titleKey, subtitleKey, srcKey;

  switch (id) {
    case 0:
      titleKey = currentValuationId
        ? "landing-page.discover-title-with-valuation"
        : "landing-page.discover-title";
      subtitleKey = currentValuationId
        ? "landing-page.discover-subtitle-with-valuation"
        : "landing-page.discover-subtitle";
      srcKey = currentValuationId
        ? `url(/images/landing-page/landing-page-sign-in-0.png)`
        : getPropertyImage();
      break;
    case 1:
      titleKey = currentValuationId
        ? "landing-page.financial-title-with-valuation"
        : "landing-page.financial-title";
      subtitleKey = currentValuationId
        ? "landing-page.financial-subtitle-with-valuation"
        : "landing-page.financial-subtitle";
      srcKey = currentValuationId
        ? "url(/images/landing-page/landing-page-sign-in-1.png)"
        : "url(/images/landing-page/landing-page-1.png)";
      break;
    case 2:
      titleKey = currentValuationId
        ? "landing-page.unlock-title-with-valuation"
        : "landing-page.unlock-title";
      subtitleKey = currentValuationId
        ? "landing-page.unlock-subtitle-with-valuation"
        : "landing-page.unlock-subtitle";
      srcKey = currentValuationId
        ? "url(/images/landing-page/landing-page-sign-in-2.png)"
        : "url(/images/landing-page/landing-page-2.png)";
      break;
  }

  return {
    id,
    title: t(titleKey),
    subtitle: t(subtitleKey),
    src: srcKey
  };
};

export const getPropertyImage = (
  valuations,
  getURLValuationId,
  getStaticMap
) => {
  if (valuations && getURLValuationId()) {
    const currentValuation = valuations[getURLValuationId()]?.basicValuation;

    if (currentValuation?.image?.length) {
      return `url(${currentValuation?.image})`;
    }
    if (currentValuation?.latitude && currentValuation?.longitude) {
      return `url(${getStaticMap(
        currentValuation?.latitude,
        currentValuation?.longitude
      )})`;
    }
  }

  return `url(/images/landing-page/landing-page-0.png)`;
};

export const galleryOrder = [
  "general",
  "facade",
  "living_room",
  "kitchen",
  "bedroom",
  "bathroom",
  "terrace",
  "garage",
  "storage_room",
  "entrance",
  "portal",
  "commons",
  "others"
];

export const MORTGAGE_PROVIDERS = {
  1: "ABANCA",
  2: "ANDBANK",
  3: "BANCA MARCH",
  4: "BANCO COOPERATIVO ESPAÑOL",
  5: "BANCO SABADELL",
  6: "BANCO SANTANDER",
  7: "BANKINTER",
  8: "BBVA",
  9: "CAIXABANK",
  10: "CAJA RURAL REGIONAL",
  11: "CAJAMAR",
  12: "CAJASIETE",
  13: "CAJASUR",
  14: "CREDIT SUISSE",
  15: "DEUTSCHE BANK",
  16: "EVO BANCO",
  17: "IBERCAJA",
  18: "KUTXABANK",
  19: "MEDIOLANUM",
  20: "OPEN BANK",
  21: "PICHINCHA",
  22: "TARGOBANK",
  23: "UNICAJA",
  24: "OTRO"
};

export const SECURITY_DROPDOWN_OPTIONS = {
  systems: {
    securityAccessType: [
      {
        id: 0,
        label: "security.building-security.conserje",
        value: "Conserje"
      },
      { id: 1, label: "security.building-security.portero", value: "Portero" },
      {
        id: 2,
        label: "security.building-security.seguridad-privada",
        value: "Seguridad privada"
      },
      {
        id: 3,
        label: "security.building-security.vigilancia-24-h",
        value: "Vigilancia 24 h"
      },
      { id: 4, label: "security.building-security.ninguna", value: "Ninguna" }
    ],
    hasAlarm: [
      { id: 0, label: "labels.yes", value: true },
      { id: 1, label: "labels.no", value: false }
    ],
    hasSecCircuit: [
      { id: 0, label: "labels.yes", value: true },
      { id: 1, label: "labels.no", value: false }
    ],
    hasSecDoor: [
      { id: 0, label: "labels.yes", value: true },
      { id: 1, label: "labels.no", value: false }
    ],
    blindsType: [
      { id: 0, label: "security.blinds.madera", value: "Madera" },
      { id: 1, label: "security.blinds.plástico", value: "Plástico" },
      { id: 2, label: "security.blinds.metálicas", value: "Metálicas" },
      {
        id: 3,
        label: "security.blinds.ver-observaciones",
        value: "Ver observaciones"
      },
      {
        id: 4,
        label: "security.blinds.persianas-de-seguridad",
        value: "Persianas de seguridad"
      },
      { id: 5, label: "security.blinds.no-tiene", value: "No tiene" },
      { id: 6, label: "N/A", value: "N/A" }
    ],
    windowGlazing: [
      { id: 1, label: "security.window-glazing.1", value: "1" },
      {
        id: 2,
        label: "security.window-glazing.2",
        value: "2"
      },
      {
        id: 3,
        label: "security.window-glazing.3",
        value: "3"
      },
      {
        id: 4,
        label: "security.window-glazing.4",
        value: "4"
      },
      {
        id: 5,
        label: "security.window-glazing.5",
        value: "5"
      },
      {
        id: 6,
        label: "security.window-glazing.6",
        value: "6"
      }
    ],
    hasBars: [
      { id: 0, label: "labels.yes", value: true },
      { id: 1, label: "labels.no", value: false }
    ],
    alarmType: [
      {
        id: 0,
        label: "security.dropdown-values.sí,-con-conexión-a-central-de-alarmas",
        value: "Sí, con conexión a central de alarmas"
      },
      {
        id: 1,
        label: "security.dropdown-values.sí,-sin-conexión-a-central-de-alarmas",
        value: "Sí, sin conexión a central de alarmas"
      },
      { id: 2, label: "security.dropdown-values.sí", value: "Sí" },
      { id: 3, label: "security.dropdown-values.no", value: "No" },
      {
        id: 4,
        label: "security.dropdown-values.se-desconoce",
        value: "Se desconoce"
      }
    ],
    doorType: [
      {
        id: 0,
        label: "security.dropdown-values.sí,-acorazada",
        value: "Sí, acorazada"
      },
      {
        id: 1,
        label: "security.dropdown-values.sí,-blindada",
        value: "Sí, blindada"
      },
      { id: 2, label: "security.dropdown-values.sí", value: "Sí" },
      { id: 3, label: "security.dropdown-values.no", value: "No" },
      {
        id: 4,
        label: "security.dropdown-values.se-desconoce",
        value: "Se desconoce"
      }
    ]
  },
  access: {
    houseUseType: [
      {
        id: 0,
        label: "security.dropdown-values.1ª-residencia",
        value: "1ª Residencia"
      },
      {
        id: 1,
        label: "security.dropdown-values.2ª-residencia",
        value: "2ª Residencia"
      },
      { id: 2, label: "security.dropdown-values.oficina", value: "Oficina" }
    ]
  }
};

export const CURRENT_HOUSE_USE_AFTER_6_MONTHS_OPTIONS = [
  { id: 0, label: "security.status.dropdown.0", value: 0 },
  { id: 1, label: "security.status.dropdown.1", value: 1 },
  { id: 2, label: "security.status.dropdown.2", value: 2 },
  { id: 3, label: "security.status.dropdown.3", value: 3 },
  { id: 4, label: "security.status.dropdown.4", value: 4 },
  { id: 5, label: "security.status.dropdown.5", value: 5 },
  { id: 6, label: "security.status.dropdown.6", value: 6 },
  { id: 7, label: "security.status.dropdown.7", value: 7 },
  { id: 8, label: "security.status.dropdown.8", value: 8 }
];

export const AddressNormStatus = {
  SUCCESS: "SUCCESS",
  FAIL: "FAIL"
};
